import React from "react";

const specializations = [
  {
    title: "Data Structures & Algorithms",
    short: "DSA",
    points: [
      "Arrays & Strings",
      "Problem Solving using Java",
    ],
  },
  {
    title: "Object-Oriented Programming",
    short: "OOPs",
    points: [
      "Encapsulation, Inheritance & Polymorphism",
      "Abstraction & Interfaces",
      "Design Principles & Reusable Code",
      "Java & JavaScript Implementations",
    ],
  },
];

function Specializations() {
  return (
    <section className="py-5 bg-white" id="specializations">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Learning & Specializations</h2>
          <p className="text-muted">
            Core computer science foundations and applied knowledge
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {specializations.map((spec, index) => (
            <div key={index} className="col-md-6 col-lg-5">
              <div
                className="h-100 p-4 rounded shadow-sm"
                style={{
                  borderTop: "4px solid #16A34A",
                  background: "#F9FAFB",
                }}
              >
                <h5 className="fw-bold text-success mb-2">
                  {spec.short}
                </h5>

                <h6 className="fw-semibold mb-3">
                  {spec.title}
                </h6>

                <ul className="small text-muted ps-3 mb-0">
                  {spec.points.map((point, idx) => (
                    <li key={idx} className="mb-2">
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Specializations;